import { ServiceResponse } from "../../api/ServiceResponse";
import { EmpShift } from "./EmpShift";

export class EmpShiftResponse extends ServiceResponse {
  empShiftList?: EmpShift[];
  count?: number;

  constructor(init?: Partial<EmpShiftResponse>) {
    super(init);
    Object.assign(this, init);
  }

  // Getters & Setters
  getEmpShiftList(): EmpShift[] | undefined {
    return this.empShiftList;
  }
  setEmpShiftList(value: EmpShift[] | undefined): void {
    this.empShiftList = value;
  }

  getCount(): number | undefined {
    return this.count;
  }
  setCount(value: number | undefined): void {
    this.count = value;
  }
}
